
    <app-layout-dialogheader1 [title]="' Select Panel type'" mat-dialog-title>
    </app-layout-dialogheader1>


<mat-dialog-content>
    <div class="section-list ">
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <!-- <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
 -->
        <div class="app-table pointer" style="overflow-y: auto;">
            <p-table #frtable [value]="listFiltered" sortMode="multiple"
                [globalFilterFields]="['brand','model']" [scrollable]="true" scrollHeight="60vh">
                <ng-template pTemplate="header">
                    <tr>
                        <th [pSortableColumn]="'brand'">Manufacturer
                            <p-sortIcon [field]="'brand'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'model'">Model
                            <p-sortIcon [field]="'model'"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr (click)="openitem(row)">
                        <td>{{row.brand}}</td>
                        <td>{{row.model}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">    
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
  </div>